import { Injectable } from "@angular/core";
import { ApiBaseService } from "./api-base.service";

@Injectable({
  providedIn: "root",
})
export class ProjectCostsService {
  constructor(private apiService: ApiBaseService) {}

  async writeProjectCost(payLoad: any): Promise<any> {
    return this.apiService.httpRequest(
      "ProjectCostService/WriteProjectCost",
      payLoad,
      true,
      true
    );
  }

  async getAllProjectCostsForProject(payLoad: any): Promise<any> {
    return this.apiService.httpRequest(
      "ProjectCostService/GetAllProjectCostsForProject",
      payLoad,
      true,
      true
    );
  }

  async getPaymentPlansForEditing(payLoad: any): Promise<any> {
    return this.apiService.httpRequest(
      "ProjectCostService/GetPaymentPlansForEditing",
      payLoad,
      true,
      true
    );
  }

  async getMilestonesPlansForNewPaymentPlan(payLoad: any): Promise<any> {
    return this.apiService.httpRequest(
      "ProjectCostService/GetMilestonesPlansForNewPaymentPlan",
      payLoad,
      true,
      true
    );
  }

  async getProjectCostOverview(payLoad: any): Promise<any> {
    return this.apiService.httpRequest(
      "ProjectCostService/GetProjectCostOverview",
      payLoad,
      true,
      true
    );
  }

  async getProjectCostsLinkedToCategory(payLoad: any): Promise<any> {
    return this.apiService.httpRequest(
      "ProjectCostService/GetProjectCostsLinkedToCategory",
      payLoad,
      true,
      true
    );
  }

  async getProjectCostDetailsPopup(payLoad: any): Promise<any> {
    return this.apiService.httpRequest(
      "ProjectCostService/GetProjectCostDetailsPopup",
      payLoad,
      true,
      true
    );
  }

  async shiftProjectCostDetailsOneWeek(payLoad: any): Promise<any> {
    return this.apiService.httpRequest(
      "ProjectCostService/ShiftProjectCostDetailsOneWeek",
      payLoad,
      true,
      true
    );
  }

  async shiftProjectCostDetailsFourWeeks(payLoad: any): Promise<any> {
    return this.apiService.httpRequest(
      "ProjectCostService/ShiftProjectCostDetailsFourWeeks",
      payLoad,
      true,
      true
    );
  }

  async shiftProjectCostDetailsThreeMonths(payLoad: any): Promise<any> {
    return this.apiService.httpRequest(
      "ProjectCostService/ShiftProjectCostDetailsThreeMonths",
      payLoad,
      true,
      true
    );
  }
  async getProjectControllingData(payLoad: any): Promise<any> {
    return this.apiService.httpRequest(
      "ProjectCostService/GetProjectControllingData",
      payLoad,
      true,
      true
    );
  }

  async getProjectCostCategories(payLoad: any): Promise<any> {
    return this.apiService.httpRequest(
      "ProjectCostService/GetProjectCostCategories",
      payLoad,
      true,
      true
    );
  }

  async writeProjectCostCategory(payLoad: any): Promise<any> {
    return this.apiService.httpRequest(
      "ProjectCostService/WriteProjectCostCategory",
      payLoad,
      true,
      true
    );
  }

}
